import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BundlePricing from "@/components/sections/BundlePricing";
import ConsultationDialog from "@/components/ConsultationDialog";
import { Reveal } from "@/lib/motion";

export default function PricingPage() {
  const navigate = useNavigate();
  const [consultOpen, setConsultOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Pricing & Service Bundles | WebsiteTech.pro";
  }, []);

  const onSelect = (pkg) => {
    if (pkg.custom) { setSelected(pkg); setConsultOpen(true); return; }
    setSelected(pkg); setConsultOpen(true);
  };

  return (
    <>
      <Navbar />
      <main className="pt-24" data-testid="pricing-page">
        <section className="relative overflow-hidden hero-bg border-b border-slate-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
            <span className="overline">Pricing</span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mt-3 leading-[1.03] max-w-3xl mx-auto">
              Simple bundles. Serious growth.
            </h1>
            <p className="text-lg md:text-xl text-slate-500 mt-6 leading-relaxed max-w-2xl mx-auto">
              Every WebsiteTech bundle combines strategy, technology and AI into one managed growth engine. Switch between INR and USD below.
            </p>
            <div className="flex flex-wrap gap-3 mt-8 justify-center">
              <Link to="/growth-advisor" data-testid="pricing-advisor-cta" className="btn-primary rounded-xl px-6 py-3.5 flex items-center gap-2 text-sm">
                <Sparkles size={15} /> Get a Recommended Bundle
              </Link>
              <button onClick={() => navigate("/lead-generation")} className="btn-outline rounded-xl px-6 py-3.5 flex items-center gap-2 text-sm">
                Explore Services <ArrowRight size={15} />
              </button>
            </div>
          </div>
        </section>

        <BundlePricing defaultCurrency="USD" onSelect={onSelect} />

        <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <Reveal>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900">Need something tailored?</h2>
            <p className="text-slate-500 mt-3">
              Every business is different. Talk to us for a custom scope, multi-location plans, or the fully managed PERFORMANCE engine.
            </p>
            <button onClick={() => { setSelected(null); setConsultOpen(true); }} className="btn-primary rounded-xl px-6 py-3.5 mt-6 inline-flex items-center gap-2 text-sm" data-testid="pricing-contact-cta">
              Talk to a Growth Specialist <ArrowRight size={15} />
            </button>
          </Reveal>
        </section>
      </main>
      <Footer />
      <ConsultationDialog
        open={consultOpen}
        onOpenChange={setConsultOpen}
        context={{ service_interest: selected?.name || "Service Bundles", source: "Pricing Page" }}
      />
    </>
  );
}
